import { requestHTML } from '@tv2/lib-core/request';
import config from '../config/endpoints';

/**
 * Fetches image URL's from s3 and creates ordered list for CAF.
 * @param {resolve} resolve - Resolve from promise.
 */
const fetchSlideshowImages = async (resolve: (value: string[] | undefined) => void) => {
  const slideshowImages = await requestHTML(config.slideshowBucket, {})
    .then(response => {
      const dataResponse = response as { data: string };
      if (dataResponse.data) {
        return new window.DOMParser().parseFromString(dataResponse.data, 'text/xml');
      }
    })
    .then(document => {
      if (document) {
        const [first, ...rest] = Array.from(document.querySelectorAll('Contents > Key'))
          .map(key => `${config.slideshowBucket}/${key.textContent}`)
          .sort();
        // because first have to be last
        return [...rest, first].filter(url => typeof url === 'string');
      }
    });
  resolve(slideshowImages);
};

/**
 * Fetches image URL's from s3 and uses them to show CAF slideshow.
 * @param {playerSelector} playerSelector - Selector to get player element.
 */
export const setSlideshow = async (playerSelector = 'castPlayer') => {
  try {
    const slideshowImages = await new Promise<string[] | undefined>((resolve, reject) => {
      setTimeout(reject, 10000);
      fetchSlideshowImages(resolve);
    });

    if (slideshowImages && slideshowImages.length > 0) {
      const playerElement = document.getElementById(playerSelector);
      const domManipulators = {
        appendSlideshowImage: (el: HTMLElement, number: number, image: string) =>
          el.style.setProperty(`--slideshow-image-${number}`, `url("${image}")`),
        addSplashImage: (el: HTMLElement, image: string) =>
          el.style.setProperty(`--splash-image`, `url("${image}")`),
      };

      if (playerElement) {
        slideshowImages.forEach((e, i) =>
          domManipulators.appendSlideshowImage(playerElement, 1 + i, e)
        );

        const lastSlideshowImage = slideshowImages.pop();
        lastSlideshowImage && domManipulators.addSplashImage(playerElement, lastSlideshowImage);
      }
    }
  } catch (err: any) {
    // eslint-disable-next-line no-console
    console.error('Something went wrong fetching slideshow', err);
  }
};
